var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.58451 0 0 4.3331 0 10.1852C0 13.2465 1.25493 15.8915 3.29789 17.719C3.46901 17.8732 3.57254 18.0866 3.58099 18.3169L3.63803 20.1845C3.65704 20.7803 4.27183 21.1669 4.8169 20.9282L6.9 20.0092C7.07746 19.931 7.27394 19.9162 7.45986 19.9669C8.4169 20.231 9.43732 20.3704 10.5 20.3704C16.4155 20.3704 21 16.0373 21 10.1852C21 4.3331 16.4155 0 10.5 0Z",
    fill: "#00B2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19557 13.1641L7.28008 8.27113C7.77022 7.49367 8.82233 7.2993 9.55754 7.85071L12.0104 9.69085C12.2364 9.85987 12.5449 9.85775 12.7688 9.68874L16.0815 7.17466C16.523 6.83874 17.1019 7.36902 16.804 7.83804L13.7216 12.7289C13.2315 13.5063 12.1794 13.7007 11.4442 13.1493L8.99134 11.3092C8.76529 11.1401 8.45684 11.1423 8.23289 11.3113L4.9181 13.8275C4.47656 14.1634 3.89768 13.6331 4.19557 13.1641Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.a9159ccc48834b6bcec6c01a6f5d241a.svg";
export { ForwardRef as ReactComponent };